import { render } from "./UpcomingMatches.vue?vue&type=template&id=02c22786&ts=true"
import script from "./UpcomingMatches.vue?vue&type=script&lang=ts"
export * from "./UpcomingMatches.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__